import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Objects from "@/pages/Objects";
import ObjectDetail from "@/pages/ObjectDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Quotes from "@/pages/Quotes";
import Workers from "@/pages/Workers";
import Finances from "@/pages/Finances";
import Contracts from "@/pages/Contracts";
import ContractDetail from "@/pages/ContractDetail";
import Reminders from "@/pages/Reminders";
import Planning from "@/pages/Planning";
import CalendarPage from "@/pages/CalendarPage";
import Tools from "@/pages/Tools";
import Leads from "@/pages/Leads";
import Settings from "@/pages/Settings";
import "@/App.css";

function AppRouter() {
  const location = useLocation();
  // Detect Emergent Auth callback in URL fragment BEFORE anything else runs
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login"           element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password"  element={<ResetPassword />} />

      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/objects" element={<Objects />} />
        <Route path="/objects/:id" element={<ObjectDetail />} />
        <Route path="/clients"  element={<ProtectedRoute adminOnly><Clients /></ProtectedRoute>} />
        <Route path="/clients/:id" element={<ProtectedRoute adminOnly><ClientDetail /></ProtectedRoute>} />
        <Route path="/quotes"   element={<ProtectedRoute adminOnly><Quotes /></ProtectedRoute>} />
        <Route path="/workers"  element={<ProtectedRoute adminOnly><Workers /></ProtectedRoute>} />
        <Route path="/finances" element={<ProtectedRoute adminOnly><Finances /></ProtectedRoute>} />
        <Route path="/contracts" element={<ProtectedRoute adminOnly><Contracts /></ProtectedRoute>} />
        <Route path="/contracts/:id" element={<ProtectedRoute adminOnly><ContractDetail /></ProtectedRoute>} />
        <Route path="/reminders" element={<ProtectedRoute adminOnly><Reminders /></ProtectedRoute>} />
        <Route path="/planning" element={<ProtectedRoute adminOnly><Planning /></ProtectedRoute>} />
        <Route path="/calendar" element={<ProtectedRoute adminOnly><CalendarPage /></ProtectedRoute>} />
        <Route path="/tools"    element={<ProtectedRoute adminOnly><Tools /></ProtectedRoute>} />
        <Route path="/leads"    element={<ProtectedRoute adminOnly><Leads /></ProtectedRoute>} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
